module.exports = __webpack_public_path__ + "static/media/air_conditioning.86d9c0c1.svg";